export function dashboardHjBulletinsItemTemplate($templateCache) {
    'ngInject';
    const path = "/Scripts/Page/Home/apex-dashboard-item-template-hj-bulletins.html";
    const html = /*html*/`<apex-bulletins-dashboard-container></apex-bulletins-dashboard-container>`;
    $templateCache.put(path, html);
}

export function dashboardHjBulletinsListItemTemplate($templateCache) {
    'ngInject';
    const path = "/Scripts/Page/Home/apex-dashboard-list-item-template-hj-bulletins.html";
    const html = /*html*/`
        <p ng-if="dashboard.count === 0">No unacknowledged messages from Herb-Joy at this time.</p>
        <p ng-if="dashboard.count > 0">
            You must acknowledge {{ dashboard.count === 1 ? "1 message" : dashboard.count + " messages" }} from
            Herb-Joy in order to continue using the site.
        </p>`;
    $templateCache.put(path, html);
}
